import React, { Component } from "react";
import { toastContainer } from "../../utils/toast";
import { isMobile } from "../../utils/deviceInfo";
import "./trivia-survey.css";
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import { GiBigGear, GiOpenTreasureChest } from "react-icons/gi";
import { CSVLink } from "react-csv";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutDataLines,
  LayoutRowLines,
} from "../../components/TableComponents/RowCardShadow/RowCardShadow";

import { showAsAnonymous, SURVEY_LIST } from "./data";
import ReactTooltip from "react-tooltip";
import If from "../../components/Shared/If";
import {
  BiDotsHorizontal,
  BiDownArrowAlt,
  BiEditAlt,
  BiUpArrowAlt,
  BiX,
} from "react-icons/bi";
import { BsDownload, BsThreeDots } from "react-icons/bs";
import { orderBy } from "lodash";
import RewardCreateModal from "./Components/RewardCreateModal";

import EmptyTable from "../../components/EmptyTable/EmptyTable";
import {
  profilePicValidityCheck,
  Spinner,
  triviaListCategories,
} from "../../utils/constants";
import RewardsModalDetails from "./Components/RewardsModalDetails";
import RewardEditModal from "./Components/RewardEditModal";
import RewardDeleteModal from "./Components/DeleteRewardsModal";
import CreateTriviaModalMain from "./Components/CreateTrivia/CreateTriviaModalMain";

class TriviaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newGeneratedSurvey: null,
      rewardList: [],
      hoveredSurvey: null,
      trivvyCatModal: false,
      optionsPopoverOpen: null,
      detailsModalOpen: false,
      trivvyCatModal: false,
      detailsModalData: null,
      invidualItemAction: {
        type: null,
        item: null,
      },
      loadingCreateTrivia: false,
      currentPage: 1,
      openEditModal: false,
      editModalData: null,
      deleteModalOpen: false,
      deleteModalData: null,
      closeModalOpen: false,
      closeModalId: null,
      openCreateTrivvy: false,
    };
  }
  // 6539c18cc96ae27405744df6

  showEditModal = (data) => {
    this.setState({ openEditModal: true, editModalData: data });
  };

  openCloseConfirmModal = (id) => {
    this.setState({
      closeModalOpen: true,
      closeModalId: id,
    });
  };

  closeCloseConfirmModal = () => {
    this.setState({
      closeModalOpen: false,
      closeModalId: null,
    });
  };

  closeEditModal = () => {
    this.setState({ openEditModal: true, editModalData: null });
  };
  showDeleteModal = (data) => {
    this.setState({ deleteModalOpen: true, deleteModalData: data });
  };

  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: true, deleteModalData: null });
  };

  handleAfterDelete = (data) => {
    const rewards = [...this.state.rewardList];

    const index = rewards.findIndex((x) => x._id == data._id);

    if (index >= 0) {
      rewards.splice(index, 1);

      this.setState({ rewardList: rewards });
    }

    this.closeDeleteModal();
  };

  updateEditModalData = (data) => {
    const { detailsModalOpen, detailsModalData } = this.state;
    const rewards = [...this.state.rewardList];
    const index = rewards.findIndex((x) => x._id == data._id);

    if (index >= 0) {
      rewards[index] = data;
      if (detailsModalOpen) {
        this.setState({
          detailsModalData: {
            ...detailsModalData,
            ...data,
          },
        });
      }
      this.setState({ rewardList: rewards });
    }
    this.closeEditModal();
  };
  componentDidMount() {
    const { organizationId } = this.props.user.profile;

    if (isMobile) {
      this.props.updateNavBar({
        title: "Trivvy",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
        optionsPopoverOpen: null,
      });
    } else {
    }

    let that = this;

    //axios.get(url.findOrgById(organizationId._id)).then(({ data }) => {
    //  const payload = data.data;
    //  that.props.orgChangeSuccess(payload);
    //});

    this.retrieveSurveys(1);

    this.props.setCurrentTrivia(null);
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      );
    }
  }

  handleBottomScroll = () => {
    // this.setState({ currentPage: this.state.currentPage + 1 }, () => {
    //   this.retrieveSurveys(this.state.currentPage);
    // });
  };

  retrieveSurveys = (page) => {
    const { sortParams } = this.props;
    axios
      .get(url.getTriviaRewardsList)
      .then(({ data }) => {
        const params = new URLSearchParams(window.location.search);
        const singleRewardId = params.get("rewardId");
        if (singleRewardId) {
          const rewardObject = data.data.find((x) => x._id == singleRewardId);
          if (rewardObject) {
            this.setState({
              detailsModalData: rewardObject,
              detailsModalOpen: true,
            });
          }
        }
        this.setState(
          {
            rewardList: [...data.data],
          },
          () => {
            this.handleSortChange(sortParams.sortBy, sortParams.sortOrder);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleSortChange = (key, order) => {
    let surveys = [...this.state.rewardList];

    switch (key) {
      case "name":
        surveys = orderBy(surveys, (itm) => itm["rewardName"].toLowerCase(), [
          order,
        ]);
        break;
      case "rewardText":
        surveys = orderBy(surveys, (itm) => itm["rewardText"].toLowerCase(), [
          order,
        ]);
        break;

      case "linkedTrivvys":
        surveys = orderBy(
          surveys,
          (itm) => itm.linkedTrivias && itm.linkedTrivias.length,
          [order]
        );
        break;
      case "createdDate":
        surveys = orderBy(surveys, (itm) => itm.createdOn, [order]);
        break;
      case "rewardDate":
        surveys = orderBy(surveys, (itm) => itm.rewardDate, [order]);
        break;
      default:
        surveys = orderBy(surveys, (itm) => itm[key], [order]);
        break;
    }
    this.setState({ rewardList: surveys });
  };

  sortComponent = (key) => {
    const { sortParams } = this.props;
    // console.log('key --- ', key)
    if (JSON.stringify(sortParams.sortBy) === JSON.stringify(key)) {
      if (sortParams.sortOrder === "desc") {
        return (
          <BiDownArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "asc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      } else {
        return (
          <BiUpArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "desc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      }
    } else {
      return (
        <BiUpArrowAlt
          size={"13px"}
          onClick={() => this.changeSortField(key, "desc")}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      );
    }
  };

  openRewardModal = (data) => {
    console.log("RewardOPEN! ----");
    this.setState({
      detailsModalData: data,
      detailsModalOpen: true,
    });
  };

  closeDetailsModal = () => {
    this.setState({
      detailsModalData: null,
      detailsModalOpen: false,
    });
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    });
  };

  updateDataInRow = (id, key, value) => {
    const rewards = [...this.state.rewardList];
    const currentIndex = rewards.findIndex((x) => x._id == id);
    if (currentIndex >= 0) {
      rewards[currentIndex][key] = value;

      this.setState({ rewardList: rewards });
    }
  };

  addDataInRow = (data) => {
    const rewards = [...this.state.rewardList];
    rewards.unshift(data);
    this.setState({ rewardList: rewards });
  };

  showTotalResponses = (itm) => {
    let sum = itm.linkedTrivias.reduce((sum, obj) => {
      return sum + (obj.responses || 0); // Adds obj.age to sum, defaults to 0 if obj.age is undefined
    }, 0);
    // console.log("showTotalResponses---- ", sum);
    return sum;
  };

  getDataForExportResult = () => {
    const { rewardList } = this.state;

    if (rewardList && rewardList.length) {
      const newList = rewardList.map((x) => ({
        rewardName: x.rewardName || "NA",
        rewardText: x.rewardText || "NA",
        totalRounds: x.linkedTrivias ? x.linkedTrivias.length : 0,
        rewardStatus: x.rewardDate
          ? moment().isSameOrBefore(moment(x.rewardDate))
            ? "In - Progress"
            : "Closed"
          : "NA",
        linkedTriviasNames:
          x.linkedTrivias && x.linkedTrivias.length
            ? x.linkedTrivias.map((y) => y.triviaName || "").join(" , ")
            : "",
        totalWinners: x.rewardWinners ? x.rewardWinners.length : 0,
        totalResponses: this.showTotalResponses(x),
        totalWinnersNames:
          x.rewardWinners && x.rewardWinners.length
            ? x.rewardWinners
                .map((k) => `${k.userFirstName || ""} ${k.userLastName || ""}`)
                .join(" , ")
            : "No winners of the reward yet",
      }));

      return newList;
    } else {
      return [];
    }
  };

  renderRowOptions = (item) => {
    const { optionsPopoverOpen } = this.state;
    return (
      <div className="cursor-pointer">
        <span
          id={`surveyListRow_${item._id}`}
          onClick={() => this.setState({ optionsPopoverOpen: item._id })}
          className="cursor-pointer"
        >
          <BsThreeDots />
        </span>

        <Popover
          isOpen={optionsPopoverOpen == item._id}
          target={`surveyListRow_${item._id}`}
          toggle={() => this.setState({ optionsPopoverOpen: null })}
          placement="bottom"
          hideArrow
          className="surveyListRow_Popover"
        >
          <PopoverBody className="">
            <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={() => {
                this.showEditModal(item);
              }}
            >
              Edit
            </div>

            <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={() => {
                this.openCloseConfirmModal(item._id);
              }}
            >
              Close Reward
            </div>

            <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={() => {
                this.showDeleteModal(item);
              }}
            >
              Delete
            </div>
          </PopoverBody>
        </Popover>
      </div>
    );
  };

  editRewardModalOpen = (reward) => {
    this.setState({
      openEditModal: true,
      editModalData: reward,
    });
  };

  handleCloseReward = () => {
    axios
      .put(url.updateReward(this.state.closeModalId), {
        rewardDate: moment()
          .subtract(1, "day")
          .endOf("day")
          .toDate(),
      })
      .then(({ data }) => {
        toastContainer("Closed successfully", "success");
        this.updateEditModalData(data.data);
      })
      .catch((err) => {
        toastContainer("Error while updating", "error");
      });
  };

  openCreateTrivvy = () => {
    this.setState({
      trivvyCatModal: false,
      openCreateTrivvy: true,
    });
  };

  render() {
    const isAdmin =
      this.props.user.profile.orgAdmin ||
      this.props.user.profile.role == "Admin";

    const {
      rewardList,
      detailsModalOpen,
      detailsModalData,
      trivvyCatModal,
      openEditModal,
      editModalData,
      deleteModalOpen,
      deleteModalData,
      closeModalOpen,
      closeModalId,
      openCreateTrivvy,
    } = this.state;
    const tableCols = {
      name: 2,
      linkedTrivvys: 1,
      rewardDate: 2,
      winners: 3,
      rewardTxt: 2,
      responses: 1,
      action: 1,
    };

    const tableColsMobile = {
      linkedTrivvys: 2,
      rewardDate: 2,
      // createdDate: 2,
      winners: 3,
      rewardTxt: 2,
      action: 1,
      responses: 2,
    };

    const rewards_csv_headers = [
      { label: "Reward Name", key: "rewardName" },
      { label: "Reward", key: "rewardText" },
      { label: "Rounds of trivvy", key: "totalRounds" },
      { label: "Status", key: "rewardStatus" },
      {
        label: "Total Responses",
        key: "totalResponses",
      },
      {
        label: "Linked Trivias Names",
        key: "linkedTriviasNames",
      },
      {
        label: "Total Winners",
        key: "totalWinners",
      },
      {
        label: "Winners names",
        key: "totalWinnersNames",
      },
    ];
    return (
      <div className="reward_page">
        {console.log({ rewardList })}
        {isAdmin && !isMobile && (
          <Button
            className="trivia-action-button-main add-reward-btn"
            style={{backgroundColor:'#fff'}}
            onClick={() => {
              this.setState({
                trivvyCatModal: true,
              });
            }}
          >
            Set reward <GiOpenTreasureChest />
          </Button>
        )}

        {openCreateTrivvy && (
          <CreateTriviaModalMain
            open={openCreateTrivvy}
            onClose={() => {
              this.setState({ openCreateTrivvy: false });
            }}
            setCreateModalState={() => {}}
            onAddSuccess={() => {
              this.setState({
                openCreateTrivvy:false
              })

              toastContainer("Created trivvy successfully","success")
            }}
            user={this.props.user}
            addTrivvySuccessFromTemplates={() => {
              this.setState({
                openCreateTrivvy:false
              })
              toastContainer("Created trivvy successfully","success")
            }}
            goToRewards={() => {}}
            canCreateRewards={false}
            fromRewards={true}

          />
        )}

        {closeModalOpen && closeModalId ? (
          <Modal isOpen={true}>
            <ModalHeader toggle={this.closeCloseConfirmModal}>
              Close Reward
            </ModalHeader>
            <ModalBody>
              <h5>Are yo sure you want to close this reward?</h5>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={this.closeCloseConfirmModal}>
                Cancel
              </Button>
              <Button color="danger" onClick={this.handleCloseReward}>
                Yes
              </Button>
            </ModalFooter>
          </Modal>
        ) : (
          ""
        )}

        {openEditModal && editModalData && (
          <RewardEditModal
            editData={editModalData}
            open={openEditModal}
            onClose={this.closeEditModal}
            setEditData={this.updateEditModalData}
          />
        )}

        {deleteModalOpen && deleteModalData && (
          <RewardDeleteModal
            data={deleteModalData}
            open={deleteModalOpen}
            onClose={this.closeDeleteModal}
            handleAfterDelete={this.handleAfterDelete}
          />
        )}

        {!isMobile && rewardList && rewardList.length ? (
          <CSVLink
            data={this.getDataForExportResult()}
            headers={rewards_csv_headers}
            filename={`Rewards-${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
            className="ml-4 btn trivia-action-button-main trivvy-export-table-btn"
          >
            {"Export to CSV"} <BsDownload size={13} />
          </CSVLink>
        ) : (
          ""
        )}

        {isMobile && (
          <UncontrolledDropdown className="ml-3" direction="down">
            <DropdownToggle className="trivia-action-button-main">
              <GiBigGear /> Reward options
            </DropdownToggle>
            <DropdownMenu className="pt-2 pr-2 mt-2">
              <DropdownItem
                onClick={() => {
                  this.setState({
                    trivvyCatModal: true,
                  });
                }}
                className="my-1"
              >
                Set Reward <GiOpenTreasureChest />
              </DropdownItem>
              <DropdownItem className="my-1">
                {rewardList && rewardList.length ? (
                  <CSVLink
                    data={this.getDataForExportResult()}
                    headers={rewards_csv_headers}
                    filename={`Rewards-${moment().format("MM/DD/YYYY")}.csv`}
                    separator={","}
                    target="_blank"
                    className="text-dark"
                  >
                    {"Export to CSV"} <BsDownload size={13} />
                  </CSVLink>
                ) : (
                  ""
                )}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        )}

        {trivvyCatModal && (
          <RewardCreateModal
            open={trivvyCatModal}
            onClose={() => this.setState({ trivvyCatModal: false })}
            //  onAddSuccess={this.handleAfterAddTrivia}
            libraryList={this.props.libraryList}
            history={this.props.history}
            addDataInRow={this.addDataInRow}
            openCreateTrivvy={this.openCreateTrivvy}
          />
        )}

        {detailsModalData && detailsModalOpen && (
          <RewardsModalDetails
            open={detailsModalOpen}
            onClose={this.closeDetailsModal}
            data={detailsModalData}
            updateDataInRow={this.updateDataInRow}
            user={this.props.user}
            history={this.props.history}
            openEditRewardModal={this.editRewardModalOpen}
          />
        )}
        {rewardList.length == -1 ? (
          <div className="d-flex justify-content-center">
            <EmptyTable
              title={"No rewards found"}
              subtitle={"You havent created any rewards yet. "}
            />
          </div>
        ) : (
          <div>
            {!isMobile ? (
              <div className="trivia_survey_list_table">
                <div className="my-4 trivia_survey_list_table_contents">
                  <LayoutRowShadow className="row-shadow-header-no-shadow">
                    <LayoutHeadingShadowLeft
                      className={"text-left"}
                      colWidth={tableCols.name}
                    >
                      Name {this.sortComponent("name")}{" "}
                    </LayoutHeadingShadowLeft>

                    <If condition={true}>
                      {/* <LayoutHeadingShadow
                        className={"justify-content-center "}
                        colWidth={tableCols.rewardDate}
                      >
                        Reward Date {this.sortComponent("rewardDate")}
                      </LayoutHeadingShadow> */}
                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.rewardTxt}
                      >
                        Reward {this.sortComponent("rewardText")}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.linkedTrivvys}
                      >
                        Rounds {this.sortComponent("linkedTrivvys")}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={"justify-content-center "}
                        colWidth={tableCols.rewardDate}
                      >
                        Status
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.responses}
                      >
                        Responses
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.winners}
                      >
                        Winners
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.action}
                      ></LayoutHeadingShadow>
                    </If>
                  </LayoutRowShadow>
                  <div
                    className={`trivia_survey_list_table_contents_scroll ${
                      rewardList.length == 0 ? "trivvy-no-results" : ""
                    }`}
                  >
                    {!isMobile && rewardList.length > 0 ? (
                      rewardList.map((item, idx) => {
                        return (
                          <LayoutRowShadow
                            //  onClick={() => this.openRewardModal(item)}
                            key={idx}
                            className={`pl-tasks-row ${
                              isMobile ? "row-scroll-width-s" : ""
                            }`}
                          >
                            <LayoutData colWidth={tableCols.name}>
                              <div
                                className="cursor-pointer d-flex"
                                data-tip={item.rewardName}
                              >
                                <div
                                  onClick={() => this.openRewardModal(item)}
                                  className="survey-item-title survey-item-title-itm"
                                >
                                  <span className="survey-item-title">
                                    {item.rewardName}
                                  </span>
                                  <div>(view)</div>
                                </div>
                              </div>

                              <ReactTooltip />
                            </LayoutData>

                            <LayoutData colWidth={tableCols.rewardTxt}>
                              <div
                                className="cursor-pointer d-flex"
                                data-tip={item.rewardText}
                              >
                                <div className="survey-item-title survey-item-title-itm">
                                  <span className="survey-item-title">
                                    {item.rewardText}
                                  </span>
                                </div>
                              </div>
                              <ReactTooltip />
                            </LayoutData>

                            <LayoutData
                              className=""
                              colWidth={tableCols.linkedTrivvys}
                            >
                              {item.linkedTrivias && item.linkedTrivias.length}{" "}
                            </LayoutData>

                            <LayoutData
                              className=""
                              colWidth={tableCols.rewardDate}
                            >
                              {" "}
                              {moment().isSameOrBefore(
                                moment(item.rewardDate)
                              ) ? (
                                <span className="reward-txt-badge-container-main">
                                  <Badge color="success">In Progress</Badge>
                                  <div className="rewards-list-status-col-days">
                                    Closing in{" "}
                                    {moment(item.rewardDate).diff(
                                      moment(),
                                      "days"
                                    )}{" "}
                                    days
                                  </div>
                                </span>
                              ) : (
                                <span className="reward-txt-badge-container-main">
                                  <Badge color={"secondary"}>Closed</Badge>
                                  <div className="rewards-list-status-col-days">
                                    Closed on{" "}
                                    {moment(item.rewardDate).format(
                                      "MMM D, YYYY"
                                    )}
                                  </div>
                                </span>
                              )}
                            </LayoutData>

                            <LayoutData
                              className=""
                              colWidth={tableCols.responses}
                            >
                              {item.linkedTrivias &&
                              item.linkedTrivias.length > 0
                                ? this.showTotalResponses(item)
                                : 0}
                            </LayoutData>

                            <LayoutData
                              className="main-rewards-tbl-component-winners"
                              colWidth={tableCols.winners}
                            >
                              {/* {item.linkedTrivias && item.linkedTrivias.length} */}

                              {item &&
                              item.rewardWinners &&
                              item.rewardWinners.length > 0 ? (
                                item.rewardWinners.map((e) => {
                                  return (
                                    <div className="trivia-top3-tbl-row">
                                      <span
                                        style={{
                                          display: "flex",
                                          gap: "0.3em",
                                          flexDirection: "row",
                                        }}
                                      >
                                        {showAsAnonymous(
                                          this.props.user.profile,
                                          e
                                        ) ? (
                                          <span
                                            style={{ position: "relative" }}
                                          >
                                            <span
                                              className="spotlightUserInitials"
                                              data-letters={"AU"}
                                            />
                                          </span>
                                        ) : (
                                          <span
                                            style={{ position: "relative" }}
                                          >
                                            {/* {idx==0?
                                               <FaCrown size={'17'} className="reward-winners-top-tbl-img"/>:
                                               <img src={awardIcon} className="awardSpotlight reward-winners-top-tbl-img" />
                                               }  */}
                                            {profilePicValidityCheck(
                                              e.userProfilePic
                                            ) ? (
                                              <img
                                                src={e.userProfilePic}
                                                className="spotlightImage"
                                              />
                                            ) : (
                                              <span
                                                className="spotlightUserInitials"
                                                data-letters={this.getInitials({
                                                  firstName: e.userFirstName,
                                                  lastName: e.userLastName,
                                                })}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </span>
                                    </div>
                                  );
                                })
                              ) : (
                                <span
                                  className="f-12"
                                  style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  No winners of the reward yet
                                </span>
                              )}
                            </LayoutData>

                            <LayoutData
                              className=""
                              colWidth={tableCols.action}
                            >
                              {this.renderRowOptions(item)}
                            </LayoutData>
                          </LayoutRowShadow>
                        );
                      })
                    ) : (
                      <span>No rewards found</span>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="trivia_table_mobile mt-5">
                <div className="trivia_survey_list_table_contents_scroll">
                  <Row>
                    <Col xs={5} className="px-0">
                      <Row>
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={12}
                        >
                          Name {this.sortComponent("name")}{" "}
                        </LayoutHeadingShadow>
                      </Row>

                      {rewardList.length == 0 ? (
                        <Row
                          className={
                            "planning-row-mobile-height layout-row-shadow mx-0"
                          }
                        >
                          <LayoutData colWidth={12}>
                            No rewards found
                          </LayoutData>
                        </Row>
                      ) : (
                        ""
                      )}

                      {rewardList.map((item, idx) => {
                        return (
                          <Row
                            key={idx}
                            className={"planning-row-mobile-height"}
                          >
                            <LayoutDataLines
                              colWidth={12}
                              className="py-1"
                              noFlex
                            >
                              <div className="cursor-pointer">
                                <div
                                  className="survey-item-title-itm"
                                  onClick={() => this.openRewardModal(item)}
                                >
                                  <span className="survey-item-title">
                                    {item.rewardName}
                                  </span>

                                  <div
                                    className="text-info"
                                    style={{ fontSize: "9px" }}
                                  >
                                    (View)
                                  </div>
                                </div>
                              </div>
                              <ReactTooltip />
                            </LayoutDataLines>
                          </Row>
                        );
                      })}
                    </Col>

                    <Col xs={7} className="scrollable-action-table-row pl-3">
                      <LayoutRowLines className="row-scroll-width-s">
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableColsMobile.rewardTxt}
                        >
                          Reward {this.sortComponent("rewardText")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center "}
                          colWidth={tableColsMobile.linkedTrivvys}
                        >
                          Rounds {this.sortComponent("linkedTrivvys")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center "}
                          colWidth={tableColsMobile.rewardDate}
                        >
                          Status
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center "}
                          colWidth={tableColsMobile.responses}
                        >
                          Responses
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={""}
                          colWidth={tableColsMobile.winners}
                        >
                          Winners
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={""}
                          colWidth={tableCols.action}
                        ></LayoutHeadingShadow>
                      </LayoutRowLines>

                      {rewardList.map((item, idx) => {
                        return (
                          <LayoutRowLines
                            key={idx}
                            className={`pl-tasks-row ${
                              isMobile ? "row-scroll-width-s" : ""
                            }`}
                          >
                            <LayoutDataLines
                              className="text-info"
                              colWidth={tableColsMobile.rewardTxt}
                            >
                              <div className="rew_tbl-txt-ovrflw">
                                {item.rewardText.substring(0, 30) + "..."}
                              </div>
                              <ReactTooltip />
                            </LayoutDataLines>

                            <LayoutDataLines
                              className="text-center font-13px"
                              colWidth={tableColsMobile.linkedTrivvys}
                            >
                              {item.linkedTrivias && item.linkedTrivias.length}{" "}
                            </LayoutDataLines>

                            <LayoutDataLines
                              className="text-center px-0 py-1"
                              colWidth={tableColsMobile.rewardDate}
                            >
                              {" "}
                              {moment().isSameOrBefore(
                                moment(item.rewardDate)
                              ) ? (
                                <span className="mt-2 reward-txt-badge-container-main">
                                  <Badge color="success">In Progress</Badge>
                                  <div className="rewards-list-status-col-days">
                                    Closing in{" "}
                                    {moment(item.rewardDate).diff(
                                      moment(),
                                      "days"
                                    )}{" "}
                                    days
                                  </div>
                                </span>
                              ) : (
                                <span className="mt-2 reward-txt-badge-container-main">
                                  <Badge color={"secondary"}>Closed</Badge>
                                  <div className="rewards-list-status-col-days">
                                    Closed on{" "}
                                    {moment(item.rewardDate).format(
                                      "MMM D, YYYY"
                                    )}
                                  </div>
                                </span>
                              )}
                            </LayoutDataLines>

                            <LayoutDataLines
                              className="text-center text-success font-13px"
                              colWidth={tableColsMobile.responses}
                            >
                              {item.linkedTrivias &&
                              item.linkedTrivias.length > 0
                                ? this.showTotalResponses(item)
                                : 0}
                            </LayoutDataLines>

                            <LayoutDataLines
                              className="main-rewards-tbl-component-winners justify-content-start"
                              colWidth={tableColsMobile.winners}
                            >
                              {/* {item.linkedTrivias && item.linkedTrivias.length} */}

                              {item &&
                              item.rewardWinners &&
                              item.rewardWinners.length > 0 ? (
                                item.rewardWinners.map((e) => {
                                  return (
                                    <div className="trivia-top3-tbl-row">
                                      <span
                                        style={{
                                          display: "flex",
                                          gap: "0.3em",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <span style={{ position: "relative" }}>
                                          {/* {idx==0?
                                                 <FaCrown size={'17'} className="reward-winners-top-tbl-img"/>:
                                                 <img src={awardIcon} className="awardSpotlight reward-winners-top-tbl-img" />
                                                 }  */}
                                          {e.userProfilePic &&
                                          e.userProfilePic != "null" ? (
                                            <img
                                              src={e.userProfilePic}
                                              className="spotlightImage"
                                            />
                                          ) : (
                                            <span
                                              className="spotlightUserInitials"
                                              data-letters={this.getInitials({
                                                firstName: e.userFirstName,
                                                lastName: e.userLastName,
                                              })}
                                            />
                                          )}
                                        </span>
                                      </span>
                                    </div>
                                  );
                                })
                              ) : (
                                <span
                                  className="text-danger f-12"
                                  style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  No winners of the reward yet
                                </span>
                              )}
                            </LayoutDataLines>

                            <LayoutDataLines
                              className=""
                              colWidth={tableColsMobile.action}
                            >
                              {this.renderRowOptions(item)}
                            </LayoutDataLines>
                          </LayoutRowLines>
                        );
                      })}
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.triviaList
        ? state.sortFilterParams.triviaList.sort &&
          state.sortFilterParams.triviaList.sort.hasOwnProperty("sortBy")
          ? state.sortFilterParams.triviaList.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    updateSortParams: (data) => dispatch(actionCreators.updateTriviaSort(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaList, axios));
